'use strict';

var ShiftPlanningAbsenceModalCtrl = function (gettextCatalog, Notification, ShiftPlanningDA, resources, employeeId, openAppointments, dates, modalInstance) {
    this._modalInstance = modalInstance;
    this.gettextCatalog = gettextCatalog;
    this._Notification = Notification;
    this._ShiftPlanningDA = ShiftPlanningDA;
    this.formSubmitted = false;
    this.resources = resources.filter((resource) => resource._id !== employeeId);
    this.handlingOption = 'nothing';
    this.dates = dates;
    this.selectedEmployee = null;
    this.cancelReason = '';
    this.employeeId = employeeId;
    this.openAppointments = openAppointments;

    if (this.resources.length) {
        this.selectedEmployee = this.resources[0]._id;
    }
};

ShiftPlanningAbsenceModalCtrl.prototype.abort = function () {
    this._modalInstance.close('abort');
};


ShiftPlanningAbsenceModalCtrl.prototype.save = async function () {
    if (this.handlingOption === 'nothing') {
        this._Notification.addSuccessMessage(this.gettextCatalog.getString('No change applied'));
        this._modalInstance.close('save');
        return;
    }

    await this._ShiftPlanningDA.handleAppointmentsInAbsence(
        this.employeeId,
        this.dates,
        this.handlingOption,
        this.cancelReason,
        this.selectedEmployee
    );

    if (this.handlingOption === 'cancel') {
        this._Notification.addSuccessMessage(this.gettextCatalog.getString('Appointments cancelled'));
    }

    if (this.handlingOption === 'move') {
        this._Notification.addSuccessMessage(this.gettextCatalog.getString('Appointments moved'));
    }

    this._modalInstance.close('save');
};

module.exports = ShiftPlanningAbsenceModalCtrl;
